import React from 'react';
import '../../Shared/MainMenu/MainMenuHeader.scss'
import { RiDeleteBinFill } from "react-icons/ri";


const DeleteMenuCustom = React.memo((props) => {

  return (
    <div onClick={props.deleteCustomSection}  style={props.styles} className="menu-header">
      <nav className={`menu ${props.isMenuActive ? "active" : "inactive"}`} >
        <ul>
          <li>
            <a className="cursor-pointer">
              <span>Delete Section</span>
              <i className="screen-guide-icon"><RiDeleteBinFill/></i>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
})

export default DeleteMenuCustom
